import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import "./tableInstallers.styl";
import {Routes} from "../../../router";
import {ConfigService} from "../../../helpers/services/configService";
import {UtilsService} from "../../../helpers/services/utilsService";
import {LanguageManager} from "../../../languages/languages";
import {InstallerList} from "../../../models/installer";
import {eventBus, signalNames} from "../../../bus";
import * as moment from "moment";
import {application} from "../../../stores/application";
const template = require("./tableInstallers.vue");

interface PaginationObject {
  rowsPerPage: number;
  page: number;
}

@Component({
  template: template
})
export default class TableInstallersComponent extends Vue {

  installers: any = null;
  search: string = "";
  totalItems = 0;
  pagination: PaginationObject = {
    rowsPerPage: 10,
    page: 1,
  };

  headers = [
    { text: LanguageManager.instance.i18n.t("installerUser"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("installerUserEmail"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("installerUserPhone"), align: "left", sortable: false }
  ];

  @Watch("search")
  searchHandler() {
    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}${this.search.length === 0 ? "" : `&q=${encodeURIComponent(this.search)}`}`;
    if (this.search.length > 1) {
      this.refreshInstallers(query);
    } else if (this.search.length === 0) {
      this.refreshInstallers(query);
    }
  }

  @Watch("pagination", { deep: true })
  paginationHandler() {
    console.warn("pagination watcher");

    const { page, rowsPerPage } = this.pagination;
    const query = `?page=${page}&per_page=${rowsPerPage}${this.search.length === 0 ? "" : `&q=${encodeURIComponent(this.search)}`}`;
    this.refreshInstallers(query);
  }

  created() {
    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}`;
    this.refreshInstallers(query);
    eventBus.$emit(signalNames.setToolbarOptions, {
      title: LanguageManager.instance.i18n.t("installersRequests"),
      reloadAction: () => this.refreshInstallers(query)
    });
  }

  refreshInstallers(query) {
    application.commitStartLoader(this.$store);
    // this.installers = null;
    Vue.http.get(ConfigService.automations + "/installer" + query, {})
      .then(response => {
        console.log("installer: ", response.data.data[1]);
        this.installers = response.data.data.map(installer => new InstallerList().deserialize(installer).flatten());
        this.totalItems = Number(response.data.metadata.total_count);
        console.log("this.installer: ", this.installers);
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  handleClickInstaller(installerEmail) {
    // console.log("ECCOMI");
    this.$router.push({path: Routes.installerDetail.path,  query: { email: installerEmail }});
    // this.$router.push({name: Routes.installerDetail.name,  params: { email: installerEmail }});
  }

  getDescriptionFromDateTime(date: string, time: string): string {
    return UtilsService.instance.getDescriptionFromDateTime(date, time);
  }
  getAvatar(rawVehicle: any): string {
    // const vehicle = new Vehicle().deserialize(rawVehicle);
    // return vehicle.getPicture();
    return "";
  }

}

Vue.component("cmTableInstallers", TableInstallersComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/tableInstallers/tableInstallers.ts